import {
    SelectionPanelCheckShape,
    SelectionPanelCheckStyle,
    SelectionPanelGroupComponentSpacing,
    SelectionPanelGroupLayoutStyle,
    SelectionPanelGroupStyleMode,
    SelectionPanelGroupTheme,
    YesNoSelectionPanelGroup,
} from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const AllInformationSubmittedField = () => {
    const value = useWizardDemoStore((state) => state.applicationKeyItems.allInformationSubmitted);
    const updateApplicationKeyItems = useWizardDemoStore((state) => state.updateApplicationKeyItems);

    return (
        <YesNoSelectionPanelGroup
            id='applicationAllInformationSubmitted'
            value={value}
            onChange={(submitted) => updateApplicationKeyItems({ allInformationSubmitted: submitted })}
            theme={SelectionPanelGroupTheme.Blue}
            styleMode={SelectionPanelGroupStyleMode.Condensed}
            label='All Information Submitted'
            required={true}
            layoutStyle={SelectionPanelGroupLayoutStyle.Horizontal}
            labelWidth='180px'
            wrapPanels={true}
            componentSpacing={SelectionPanelGroupComponentSpacing.StandardSpacing}
            checkShape={SelectionPanelCheckShape.Circle}
            checkStyle={SelectionPanelCheckStyle.Fill}
        />
    );
};
